import { render } from "./ProfilMenu.vue?vue&type=template&id=4e4f49cf&scoped=true"
import script from "./ProfilMenu.vue?vue&type=script&lang=js"
export * from "./ProfilMenu.vue?vue&type=script&lang=js"

import "./ProfilMenu.vue?vue&type=style&index=0&id=4e4f49cf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e4f49cf"

export default script